import { APP_ROUTES } from '@/root/shared-consts'

// URL of the ticket page for the chosen sails: /<locale>/select-tickets/<packages>/<sailRefIds>
export const getSelectTicketsPath = (locale: string, packages: string[], sailRefIds: number[]) =>
  `/${locale}${APP_ROUTES.selectTickets}/${packages.join(',')}/${sailRefIds.join(',')}`
